import { useQuery } from "@tanstack/react-query"
import { api } from "../lib/api/client"
import { useUIStore } from "../stores"
import type { SidebarCounts } from "../types"

/**
 * Hook to fetch sidebar badge counts.
 * Counts update based on the selected division.
 */
export function useSidebarCounts() {
  const selectedDivision = useUIStore((state) => state.selectedDivision)
  const divisionId = selectedDivision || "all"

  return useQuery({
    queryKey: ["sidebarCounts", divisionId],
    queryFn: async (): Promise<SidebarCounts | null> => {
      try {
        const result = await api.dashboard.sidebar(divisionId)
        return result.data || null
      } catch {
        return null
      }
    },
    staleTime: 1000 * 60 * 2, // 2 minutes
    refetchInterval: 1000 * 60 * 5, // Refetch every 5 minutes
  })
}
